import React from 'react';

import useSearchParam from '../../hooks/useSearchParam';
import SearchParam, { SearchParamProps } from '../SearchParam';

type FilterSelectionProps = Omit<SearchParamProps<string[]>, 'children'>;

const FilterSelection: React.FC<FilterSelectionProps> = ({ name, children, ...props }) => {
  const [value] = useSearchParam(name, props);

  if (value) {
    return (
      <>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return (
              <SearchParam array name={name} {...props}>
                {child}
              </SearchParam>
            );
          }

          return child;
        })}
      </>
    );
  }

  return null;
};

export default FilterSelection;
